import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getDashboardsState, getIsSelfHosted } from '@/store-selectors';
import { useDatasourceId, useEventListener } from '@/hooks';
import {
  deleteDashboard,
  loadDashboard,
  loadDashboards,
  openEditDashboardModal,
  openModal,
  openReactModal,
} from '@/actions';
import ModalAddDashboard from '@/components/modals/ModalAddDashboard';
import SendDashboard from '@/components/SendDashboard';
import { DashboardsContainer } from '@/views/DashboardList/Dashboards.styles';
import { useAppDispatch } from '@/store/hooks';
import { userAction } from '@/util/helpers/ajax-helpers';
import {
  resetDashboardIdToAppliedFiltersRefreshIdMap,
  setLastVisitedDashboardId,
} from '@/features/dashboards/dashboardsSlice';
import { DashboardList_LEGACY } from './DashboardList_LEGACY';

const DashboardList = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const datasourceId = useDatasourceId();
  const dashboards = useSelector(getDashboardsState).dashboards;
  const isSelfHosted = useSelector(getIsSelfHosted);

  React.useEffect(() => {
    dispatch(setLastVisitedDashboardId(null));
    dispatch(resetDashboardIdToAppliedFiltersRefreshIdMap());
  }, []);

  const navigateToNewDashboard = (event: Event) => {
    const newDashboardId = (event as CustomEvent).detail;
    navigate(newDashboardId);
  };

  useEventListener('trevor:DASHBOARD_CREATED', navigateToNewDashboard);

  const onAddDashboard = (e: React.MouseEvent) => {
    e.preventDefault();
    dispatch(openModal(ModalAddDashboard));
  };

  const onSetupDashboardPush =
    // @ts-expect-error: infer types.
    (dashboard, defaultDestination, reloadSchedules) => () => {
      userAction('open-dashboard-delivery-modal');
      dispatch(
        openReactModal(
          <SendDashboard
            reloadSchedules={reloadSchedules}
            defaultDestination={defaultDestination}
            dashboard={dashboard}
          />,
        ),
      );
    };

  const onLoadDashboards = () => {
    dispatch(loadDashboards());
  };

  const onLoadDashboard = (d: unknown) => () => {
    userAction('use-dashboard');
    dispatch(loadDashboard(d));
    window.scrollTo(0, 0);
  };

  const onEditDashboard = (dashboard: unknown) => (e: React.MouseEvent) => {
    e.preventDefault();
    dispatch(openEditDashboardModal(dashboard));
  };

  const onDeleteDashboard = (dashboard: unknown) => () => {
    dispatch(deleteDashboard(dashboard));
  };

  return (
    <DashboardsContainer>
      <DashboardList_LEGACY
        datasourceId={datasourceId}
        dashboards={dashboards}
        isSelfHosted={isSelfHosted}
        onAddDashboard={onAddDashboard}
        onSetupDashboardPush={onSetupDashboardPush}
        onLoadDashboard={onLoadDashboard}
        onLoadDashboards={onLoadDashboards}
        onEditDashboard={onEditDashboard}
        onDeleteDashboard={onDeleteDashboard}
      />
    </DashboardsContainer>
  );
};

export default DashboardList;
